import { SuccessAnimation } from '@postidigital/posti-components'
import { observer } from 'mobx-react-lite'
import React, { FC, useCallback, useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { StoreContext } from '../../../store'
import { AppModal } from '../../general/AppModal'
import { ContentSection } from '../../layout'
import { ResponsiveBody } from '../../typography/ResponsiveBody'

const ChangePasswordConfirmModal: FC<{ logout: () => void }> = ({ logout }) => {
  const { t } = useTranslation()
  const {
    mainViewStore,
    changePasswordStore,
    infoStore: { isStrongAuth },
  } = useContext(StoreContext)
  const { result, resetResult } = changePasswordStore

  const closeModal = useCallback(() => {
    resetResult()

    if (result?.result === 'OK' && isStrongAuth) {
      return logout()
    }

    mainViewStore.reset()
  }, [isStrongAuth, logout, mainViewStore, resetResult, result?.result])

  return (
    <AppModal id="change_password_confirmation_modal" isOpen={result?.result === 'OK'} onClose={closeModal}>
      <ContentSection style={{ justifyContent: 'center', alignItems: 'center' }}>
        <SuccessAnimation width={'130px'} height={'130px'} />
        <ContentSection>
          <ResponsiveBody>
            <b>{t(`mainView.changePassword.success.${result?.result}`)}</b>
          </ResponsiveBody>
          {result?.result === 'OK' && isStrongAuth && (
            <ResponsiveBody>{t('mainView.changePassword.logout')}</ResponsiveBody>
          )}
        </ContentSection>
      </ContentSection>
    </AppModal>
  )
}

export default observer(ChangePasswordConfirmModal)
